var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.form
    ? _c(
        "el-form",
        {
          staticClass: "form custom-form",
          attrs: {
            "label-width": "200px",
            "label-position": _vm.formLabelPosition
          }
        },
        [
          _c("div", { staticClass: "heading" }, [
            _vm.form.heading
              ? _c("h3", [_vm._v(_vm._s(_vm.form.heading))])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._l(_vm.form.form_fields, function(field, i) {
            return _c(
              "el-form-item",
              { attrs: { label: field.name, error: _vm.errors[field.id] } },
              [
                _vm.inputTypes.indexOf(field.input_type) > -1
                  ? _c("el-input", {
                      attrs: {
                        placeholder: field.placeholder,
                        type: field.input_type
                      },
                      model: {
                        value: _vm.formData[field.id],
                        callback: function($$v) {
                          _vm.$set(_vm.formData, field.id, $$v)
                        },
                        expression: "formData[field.id]"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                field.input_type == "dropdown"
                  ? _c(
                      "el-select",
                      {
                        model: {
                          value: _vm.formData[field.id],
                          callback: function($$v) {
                            _vm.$set(_vm.formData, field.id, $$v)
                          },
                          expression: "formData[field.id]"
                        }
                      },
                      _vm._l(field.choices, function(choice) {
                        return _c("el-option", {
                          key: choice.id,
                          attrs: { label: choice.name, value: choice.name }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                field.description
                  ? _c("p", { staticClass: "description" }, [
                      _vm._v(_vm._s(field.description))
                    ])
                  : _vm._e()
              ],
              1
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }